"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var omit = require("lodash.omit");
var Radium = require("radium");
var react_1 = require("react");
var components_1 = require("components");
var componentStyle = {
    base: {
        display: 'flex',
        width: '100%',
    },
    drawer: {
        height: 'calc(100vh - 64px)',
        top: 64,
        width: 0,
        overflowY: 'auto',
    },
    drawerOpen: {
        width: 296,
    },
    view: {
        flex: 1,
        overflowY: 'auto',
    },
};
var getDrawerStyle = function (style, props) { return ([
    style.drawer,
    props.drawerOpen && style.drawerOpen,
]); };
var LayoutBody = (function (_super) {
    __extends(LayoutBody, _super);
    function LayoutBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutBody.prototype.render = function () {
        var _a = omit(this.props, ['drawerOpen', 'style']), drawerItems = _a.drawerItems, children = _a.children, otherProps = __rest(_a, ["drawerItems", "children"]);
        return (React.createElement("div", __assign({ style: componentStyle.base }, otherProps),
            React.createElement(components_1.Drawer, { style: getDrawerStyle(componentStyle, this.props) }, drawerItems),
            React.createElement("div", { style: componentStyle.view }, children)));
    };
    LayoutBody = __decorate([
        Radium
    ], LayoutBody);
    return LayoutBody;
}(react_1.PureComponent));
exports.LayoutBody = LayoutBody;



//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/LayoutBody.tsx
// module id = 117
// module chunks = 0